<app-dynamic-form class="block h-full" [formConfigs]="formConfig" [formGroup]="form" />
